import { TranslationKeys } from './TranslationKeys';

export const CombinedTranslationKeys = { ...TranslationKeys };
